import { render, staticRenderFns } from "./RefundCompensationSummary.vue?vue&type=template&id=37f1bac9&scoped=true"
import script from "./RefundCompensationSummary.vue?vue&type=script&lang=js"
export * from "./RefundCompensationSummary.vue?vue&type=script&lang=js"
import style0 from "./RefundCompensationSummary.vue?vue&type=style&index=0&id=37f1bac9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1bac9",
  null
  
)

export default component.exports